import * as React from 'react';
import moment from 'moment';

export interface Props
  extends Omit<React.HTMLAttributes<HTMLTimeElement>, 'onChange'> {
  date?: Date;
  format?: string;
  interval?: number;
  onChange?: (now: number) => void;
}

export const Clock: React.FunctionComponent<Props> = ({
  date = null,
  format = 'HH:mm',
  interval = 1000,
  onChange,
  ...htmlElementProps
}) => {
  const [startTime] = React.useState(Date.now());
  const [currentTime, setCurrentTime] = React.useState(
    date ? new Date(date).getTime() : Date.now(),
  );

  React.useEffect(() => {
    const tick = setInterval(() => {
      let now = Date.now();

      if (date) {
        const difference = Date.now() - startTime;
        now = new Date(date).getTime() + difference;
      }

      setCurrentTime(now);
      if (typeof onChange === 'function') {
        onChange(now);
      }
    }, interval);

    return () => clearInterval(tick);
  }, [date, interval, startTime, onChange]);

  return (
    <time {...htmlElementProps}>{moment(currentTime).format(format)}</time>
  );
};

export default Clock;
